

exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _squid = require('squid');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
    tag: 'xo-card-loader',
    template: _template2['default'],
    props: {
        message: {
            type: 'str'
        },
        state: {
            type: 'var'
        },
        auth: {
            type: 'var'
        }
    }
});

angular.value("$xoCardLoader", $xoCardLoader);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/card-loader/directive.js
// module id = ./components/xo-ui-components/src/card-loader/directive.js
// module chunks = 1